import React, { useEffect, useState } from 'react'

import Icon from '../../../components/UI/Icon'
import DropDown from '../../../components/Input/DropDown'
import FindTutorFilterModal from './FindTutorFilterModal'

import { useDebounce } from '../../../hooks'

import { sortOptions } from './data'

import searchIcon from '../../../assets/icon/search.png'

const SearchFilter = ({ filters, onChangeFilters, setFilters }) => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const [search, setSearch] = useState('')

  const searchDebounced = useDebounce(search)

  const handleChangeSearch = (e) => {
    setSearch(e.target.value)
  }

  const handleChangeSort = (value) => {
    onChangeFilters('sort', value)
  }

  const handleOpenFilterModal = () => {
    setIsFilterModalOpen(true)
  }

  const handleCloseFilterModal = () => {
    setIsFilterModalOpen(false)
  }

  useEffect(() => {
    if (searchDebounced) {
      onChangeFilters('country_of_origin', '_')
      onChangeFilters('country_of_residence', '_')
    }

    if (filters.search !== searchDebounced) {
      onChangeFilters('search', searchDebounced)
    }
  }, [searchDebounced])

  useEffect(() => {
    if (filters.search !== search) {
      setSearch(filters.search)
    }
  }, [filters])

  return (
    <div className="flex items-center justify-between w-full mt-[24px]">
      <label htmlFor="tutor-search" className="w-[480px] relative flex items-center">
        <input
          id="tutor-search"
          placeholder="Search with keywords or tutor names"
          value={search}
          onChange={handleChangeSearch}
          className="h-[56px] pl-[24px] pr-[48px] w-full bg-transparent rounded-[10px] text-base border-[#FDFDFD] border-[1px] text-[#FDFDFD] placeholder:text-[#FDFDFD] outline-none"
        />

        <img src={searchIcon} alt="Search" draggable={false} className="absolute right-[24px]" />
      </label>

      <div className="flex justify-end items-center gap-x-4">
        <button
          className="dropdownMenuView bg-[#FDFDFD] px-[16px] h-[54px] flex items-center"
          onClick={handleOpenFilterModal}
        >
          <Icon name="filter" color="#F67443" className="w-[28px] h-[28px] mr-[8px]" />

          <span className="text-base text-[#F67443] font-medium">Filter</span>
        </button>

        <DropDown
          placeholder="Sort"
          menuItems={sortOptions}
          value={filters.sort}
          setValue={handleChangeSort}
          className="h-[54px] justify-center"
          selectedItemClassName="!font-medium !text-base"
        />
      </div>

      <FindTutorFilterModal
        open={isFilterModalOpen}
        onClose={handleCloseFilterModal}
        filters={filters}
        setFilters={setFilters}
      />
    </div>
  )
}

export default SearchFilter
